// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoDbxSfBq } from '../../../assets/images/Logos/logo-dbx-sf-bq.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoDbxSfBqIcon = /* @__PURE__ */ withLogoClass(LogoDbxSfBq);
